import React from "react";

export const ToggleSwitch = ({ label, toggled, onToggle, disabled }) => {
    return (
        <div className="relative inline-block w-12 h-6">
            {/* Hidden checkbox */}
            <input
                type="checkbox"
                id={label}
                className="sr-only peer"
                checked={toggled}
                onChange={() => !disabled && onToggle()} // Prevent toggling if disabled
                disabled={disabled}
            />
            {/* Track (label) */}
            <label
                htmlFor={label}
                className={`block w-full h-full rounded-full transition-colors duration-300 ${disabled
                    ? "bg-gray-200 cursor-not-allowed"
                    : "bg-gray-300 peer-checked:bg-green-500 cursor-pointer"
                    }`}
            />
            {/* Knob */}
            <div
                className={`absolute top-[1.5px] left-[3px] w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 transform ${toggled ? "translate-x-6" : ""
                    } ${disabled ? "bg-gray-300" : ""}`}
            />
        </div>
    );
};
